import React, { useContext } from "react";
import styled from "styled-components";
import { Link, NavLink, useLocation } from "react-router-dom";
import { UserContext } from "../../App";
import Logo from "../../logo.png";
import SearchBar from "./SearchBar";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { logOut } from "../../store/actions/authActions";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import "../../App.css";
import useRoutes from "../../utils/useRoutes";
import MenuCreateModalButton from "./MenuCreateModalButton";

// region Styles
const AsideContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: ${(props) =>
    props.$isOpen ? "var(--nav-expanded-width)" : "var(--nav-width)"};
  height: 100vh;
  background-color: #f4f5f7;
  padding: 0.5rem 0;
  transition: width 0.3s ease;
  z-index: 1001;
  overflow-y: auto;

  @media (max-width: 768px) {
    display: none;
  }
`;

const Header = styled.header`
  width: 100%;
  height: var(--header-height);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 1rem;
  background-color: #ffffff;
  z-index: 100;
  transition: padding 0.3s ease;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const HeaderImg = styled.div`
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  overflow: hidden;

  img {
    width: 40px;
  }
`;

const LogoContainer = styled.div`
    width: 100%;
    padding-left: 9rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 2rem;
`;

const LogoImage = styled.img`
  width: 100px;
  height: 37px;
`;

export const HelpMeButton = styled.button`
    background: transparent;
    position: relative;
    color: black;
    padding: 0 0.5rem;
    border-radius: 0;
    border: none;
    font-size: 1rem;
    transition: all ease 300ms;

    &::before {
        content: "";
        display: block;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 0;
        height: 1px;
        background-color: var(--bs-primary);
        transition: all ease 300ms;
    }
    
    &:hover {
        color: var(--bs-primary);
        &::before {
            width: 100%;
        }
    }
`

const Nav = styled.nav`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow-y: auto;
`;

const NavLogo = styled(NavLink)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1.5rem;
  margin-bottom: 2rem;
  color: var(--bs-primary);
  font-weight: 700;
  text-decoration: none;
`;

const NavLinkStyled = styled(NavLink)`
  display: grid;
  grid-template-columns: 3rem 1fr;
  column-gap: 1rem;
  align-items: center;
  width: 100%;
  padding: 0.5rem 1.5rem;
  color: black;
  text-decoration: none;
  transition: color 0.3s ease, background-color 0.3s ease;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  background-color: #f4f5f7;
  border-radius: 10px;

  &:hover {
    background-color: #e0e0e0;
  }

  &.active {
    background-color: #e0e0e0;
    color: black;
  }
`;

const NavIcon = styled.i`
  font-size: 2rem;
  color: black;
  width: 2rem;
  height: 2rem;
  text-align: center;
  transition: color 0.3s ease;
  place-self: center;
`;

const Label = ({ isOpen, children }) => (
  <span style={{ opacity: isOpen ? 1 : 0, transition: "opacity 0.5s ease" }}>
    {children}
  </span>
);

const MenuList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const MenuItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const CustomTooltip = styled(Tooltip)`
    color: #ffffff !important; /* Couleur du texte */
    font-size: 1rem !important; /* Taille de la police */
    -- #{$prefix}
    tooltip-color: #6f42c1;
`;

export const CreateButton = styled.button`
    background: var(--bs-primary);
    border: none;
    color: white;
    padding: 0.5rem 1rem;
    border-radius: 20px;
    font-size: 1rem;
    display: flex;
    align-items: center;
    cursor: pointer;

    &::after {
        content: "+";
        font-size: 1.2rem;
        margin-left: 0.3rem;
    }
`;

// endregion

const AsideMenu = ({ isOpen, toggleMenu, logOut }) => {
  const { user } = useContext(UserContext);
  const {menuRoutes} = useRoutes();
  const location = useLocation();

  const handleLogout = (e) => {
    e.preventDefault();
    logOut();
  };

  function isRouteActive(route) {
    return route.match.some(
      (match) =>
        (match !== "/" || location.pathname === "/") &&
        location.pathname.startsWith(match)
    );
  }

  if (!user) return null;

  return (
    <>
      <Header style={{ paddingLeft: isOpen ? "var(--nav-expanded-width)" : 0 }}>
        <LogoContainer>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "1rem"
            }}
          >
            <SearchBar type="text" placeholder="Search..." />
            <MenuCreateModalButton />
          </div>
          <div className="d-flex align-items-center gap-2">
            <HelpMeButton data-tally-open="w828Ek" data-tally-layout="modal" data-tally-emoji-text="👋" data-tally-emoji-animation="wave" data-tally-auto-close="0">Besoin d'aide ?</HelpMeButton>
            <Link to="/profile">
              <HeaderImg>
                <img
                  src="https://cdn-icons-png.flaticon.com/256/6522/6522516.png"
                  alt="Profile"
                />
              </HeaderImg>
            </Link>
          </div>
        </LogoContainer>
      </Header>
      <AsideContainer $isOpen={isOpen}>
        <Nav>
          <div>
            <MenuList>
              <MenuItem>
                <NavLogo to="#">
                  <LogoImage src={Logo} alt="Logo" onClick={toggleMenu} />
                </NavLogo>
              </MenuItem>
              {menuRoutes.map((route, index) => (
                <MenuItem key={index}>
                  <OverlayTrigger
                    placement="right"
                    overlay={
                      <CustomTooltip id={`tooltip-${index}`}>
                        {route.label}
                      </CustomTooltip>
                    }
                  >
                    <NavLinkStyled
                      to={route.path}
                      activeClassName="nothing"
                      className={`${isOpen ? "show" : ""}${
                        isRouteActive(route) ? " active" : ""
                      }`}
                    >
                      <NavIcon className={route.icon + " nav_icon"}></NavIcon>
                      {isOpen && <Label isOpen={isOpen}>{route.label}</Label>}
                    </NavLinkStyled>
                  </OverlayTrigger>
                </MenuItem>
              ))}
              <NavLinkStyled
                to="#"
                className={isOpen ? "show" : ""}
                activeClassName="logoutactive"
                onClick={handleLogout}
              >
                <NavIcon className="icon-logout icon nav_icon"></NavIcon>
                <Label isOpen={isOpen}>Déconnexion</Label>
              </NavLinkStyled>
            </MenuList>
          </div>
        </Nav>
      </AsideContainer>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    fbAuth: state.firebase.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    logOut: () => dispatch(logOut()),
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(AsideMenu);
